import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
const list = [
  {
    path: '/pack',
    component: HeaderAsideLayout,
    children: [
      { path: '/pack', component: () => import('@/pages/newScript/pack.vue') },
    ],
  },
]
export default list